// @ts-nocheck
import {InitPage} from "../index";

declare var startTime;
declare var endTime;


class IRMSRequestEpcs {
  constructor() {
    $('document').ready(function () {
      $('#from_date_time').daterangepicker({
        autoUpdateInput: false,
        "singleDatePicker": true,
        "timePicker": true,
        defaultDate: null,
        startDate: startTime || new Date(new Date().setHours(0,0,0,0)),
        locale: {
              format: 'YYYY-MM-DD HH:mm'
            }
        }).on("apply.daterangepicker", function (e, picker) {
          picker.element.val(picker.startDate.format(picker.locale.format));
      });

      $('#from-date-time').on('click', function (e) {
        e.preventDefault();
        $('#from_date_time').click();
      });

      $('#to_date_time').daterangepicker({ 
        autoUpdateInput: false,
        "singleDatePicker": true,
        "timePicker": true,
        defaultDate: null,
        startDate: endTime || new Date(new Date().setHours(23,59,59,0)),
        locale: {
              format: 'YYYY-MM-DD HH:mm'
            }
        }).on("apply.daterangepicker", function (e, picker) {
          picker.element.val(picker.startDate.format(picker.locale.format));
      });

      $('#to-date-time').on('click', function (e) {
        e.preventDefault();
        $('#to_date_time').click();
      });

      $('#export-btn').on('click', function (e) {
        $("#exportCSV").modal('show');
      });
    });
  }
}

export function LoadPage() {
  InitPage("request_epcs index", () => {
    const c = new IRMSRequestEpcs();
  });
}